'use client'

import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

// import { getStoryblokApi } from '@/lib/storyblok'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxPartnerList, RegionProps } from './PartnerList'

interface PartnerListBlokProps {
  blok: {
    title?: string
    year?: string
    regions: SbBlokData[]
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
    alignment?: SbBlokData[]
    groupStylePanel?: SbBlokData[]
    group_style_panel?: SbBlokData[]
  } & SbBlokData
}

const PartnerList: FC<PartnerListBlokProps> = ({ blok }) => {
  const stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxPartnerList
        title={blok.title || 'Introducing our 2025 Partner Cohort'}
        year={blok.year || '2025'}
        regions={blok.regions as unknown as RegionProps[]}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
      />
    </div>
  )
}

export default PartnerList
